<template>
  <div class="tpl">
    <van-nav-bar title="亿起购" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <vue-swpier :items="slide" autoplay="5000"></vue-swpier>
    
    <van-divider :style="{ borderColor: '#888888', padding: '0 120px', color: '#1baeae' }">热销商品</van-divider>
    <div class="goods">
      <van-list
        class="goodsList"
        v-model="loading"
        :finished="finished"
        @load="getGoodsList"
      >
        <!-- <van-cell v-for="item in goodsList" :key="item" :title="item.post_title" /> -->
        <router-link
          :to="'/shop/detail/'+item.id"
          class="item"
          v-for="item in goodsList"
          :key="item.id"
        >
          <van-image width="100%" height="50vw" fit="contain" radius="10px" :src="GLOBAL.IMG + item.thumbnail" />
          <div class="title">{{item.post_title}}</div>
          <div class="price">¥ {{item.price}}</div>
        </router-link>
      </van-list>
    </div>
  </div>
</template>
<script>
import vueSwpier from "@/components/vueSwiper.vue";
import Vue from "vue";
import { TreeSelect } from "vant";
import { Divider } from "vant";
import wx_share from '../../common/wx_share.js';
Vue.use(Divider);
Vue.use(TreeSelect);
export default {
  name: "goodsList",
  components: {
    vueSwpier
  },
  data() {
    return {
      categorys: [],
      secondCats: [],
      activeId: 1,
      activeIndex: 5,
      slide: [],
      goodsList: [],
      loading: false,
      finished: false,
      cPage: 1,
      cid: this.$route.params.cat,
      keyword: this.$route.params.keyword,
      scid: 0,
      smallCatList: [],
      user: { token: "",user:{id:0} },
    };
  },
  methods: {
    
    onClickLeft() {
      this.$router.go(-1);
    },
    getSlide(id) {
      this.$http
        .get(this.GLOBAL.API + "s_slide/index/slide?id=" + id, {
          params: {},
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            this.slide = data.data;
          }
        });
    },
    
    getGoodsList() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/goods/goodsList", {
          params: {
            scid: this.scid,
            cid: this.cid,
            keyword: this.keyword,
            page: this.cPage
          },
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.goodsList = this.goodsList.concat(data.data.data); //= data.data.data;
          }
        });
    }
  },

  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    let item = {"post_title":"亿家一家亿起购栏目","desc":"亿家一家亿起购商品列表，关注公众号，会有意外惊喜呦。","thumbnail":"http://yijia.sihandbms.cn/upload/default/logo.jpg"}
    wx_share.wx_share(this.GLOBAL.API,this.user,item);
    switch (this.cid) {
      case "213":
        this.getSlide(6);
        break;

      default:
        this.getSlide(5);
        break;
    }
  }
};
</script>
<style lang="scss" scoped>
.tpl {
  text-align: left;
  background-color: #f6f6f6;
}
.van-tree-select__nav{width:100px}
.secondCat{
    padding:20px 10px 20px 10px;
    display: flex;
    flex-wrap: wrap;
    .item{
        width:33%;
        text-align: center;
        padding-bottom:20px;
    }
}
.van-sidebar-item--select {
  color: brown;
}
.goodsList {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  .item {
    margin-top: 5px;
    background-color: #ffffff;
    width: 49.5%;
    border-radius: 10px;
    .title {
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0 5px 4px 5px;
      color: #333;
    }
    .price {
      color: #1baeae;
      font-size: 14px;
      text-align: left;
      padding: 4px 5px 4px 8px;
    }
  }
}
</style>